enum RouteNames {
  home = 'pt',
  conversation = 'pt-conversation',
  help = 'pt-help',
  authenticate = 'pt-auth',
  authFailed = 'pt-auth-failed',
  authChallenge = 'pt-auth-challenge',
  conversationsList = 'pt-conversations-list',
  viewTrackerIntro = 'pt-vt-info',
  viewTrackerForm = 'pt-vt-form',
  viewTrackerResult = 'pt-vt-result',
  viewTracker = 'pt-vt',
  linkExpired = 'pt-link-expired',
  tac = 'pt-tac',
  landingPage = 'pt-landing',
  widgetUnavailable = 'pt-widget-unavailable',
  guestChat = 'guest-chat',
  nonQliqChat = 'non-qliq-chat',
  quickFormPage = 'pt-quick-form-page',
}

export default RouteNames
